import React from 'react';
import {useAuth} from "../Auth";
import {Button} from "../Button";
import {Grid} from "../Grid";
import {useNavBar} from "../NavBar";
import {Select} from "../Select";
import {Card} from "../TabsRoute/components/Card";
import {Typography} from "../Typography";
import {C800CallLogsContext, C800CallLogsProvider} from "./components/800CallLogsProvider";
import {CallLogsSummaryTable} from "./components/CallLogsSummaryTable";
import {CallsByState} from "./components/CallsByState";
import {IconCallList} from './components/IconCallList';
import {LogsSvg} from "./components/LogsSvg";
import {Modal800CallLogs, Modal800CallLogsProps} from "./components/Modal800CallLogs";
import {TotalCalls} from "./components/TotalCalls";
import {columnTitle, columnTitleEnd, rowTitle, selectContainer} from "./styles";

import moment from "moment";
import {useCallLogsByDate, useCallLogsById} from "../../sdk/queries";
import {ModalNotification, ModalNotificationProps} from "./components/ModalNotification";


const yearOptions = [{label: "2026", value: "2026"},
      		     {label: "2025", value: "2025"},
		     {label: "2024", value: "2024"},
		     {label: "2023", value: "2023"},
		     {label: "2022", value: "2022"},
		     {label: "2021", value: "2021"},
		     {label: "2020", value: "2020"},
		     {label: "2019", value: "2019"},
		     {label: "2018", value: "2018"},
		     {label: "2017", value: "2017"},
		     {label: "2016", value: "2016"}];

export const C800CallLogs: React.FC = () => {
    const {userRole} = useAuth();
    const {updatePage} = useNavBar();
    React.useLayoutEffect(() => {
        // Let the navbar know the current page displayed is this one
        updatePage("800-call-logs");
    }, []);

    const [open, setOpen] = React.useState(false);

    const [openNotification, setOpenNotification] = React.useState(false);

    const [mode, setMode] = React.useState<NonNullable<Modal800CallLogsProps['mode']>>("view");
    const [currId, setCurrId] = React.useState<number | null>(null);


    const findYear = (year: string) => {
        return yearOptions.find(x => x.value === year);
    }



    return (
        <C800CallLogsProvider>
            <C800CallLogsContext.Consumer>
                {({notifyCallLogsChange, selectedYear, setSelectedYear}) => (
                    <React.Fragment>
                        <Typography leftIcon={<LogsSvg/>} variant={"h1"}>Norfolk Southern Coal Dust Complaint Call
                            Line : +1
                            (800)
                            621-0772</Typography>
                        <div css={selectContainer}>
                            <Select value={findYear(selectedYear)} options={yearOptions}
                                    onChange={value => {
                                        if (value) {
                                            setSelectedYear(value.value)
                                        }
                                    }}
                            />
                        </div>
                        <Grid lsize={"400px"} rsize={"1fr"}>
                            <TotalCalls/>
                            <CallsByState/>
                        </Grid>
                        <Modal800CallLogs
                            modalProps={{
                                open,
                                onClose() {
                                    setOpen(false);
                                },
                            }}
                            mode={mode}
                            callLogId={currId}
                            onModify={notifyCallLogsChange}
                        />
                        <ModalNotification
                            modalProps={{
                                open: openNotification,
                                onClose() {
                                    setOpenNotification(false);
                                },
                            }}
                        />
                        <Card>
                            <div css={rowTitle}>
                                <div css={columnTitle}>
                                    <Typography variant={"h3"} leftIcon={<IconCallList/>}>Call List</Typography>
                                </div>
                                {userRole === "admin" && <div css={columnTitleEnd}>
                                    <Button onClick={() => {
                                        setMode("create");
                                        setOpenNotification(prev => !prev)
                                    }}>
                                        Send Notification
                                    </Button>

                                    <Button style={{marginLeft:20}} onClick={() => {
                                        setMode("create");
                                        setOpen(prev => !prev)
                                    }}>
                                        Create
                                    </Button>
                                </div>}
                            </div>
                            <CallLogsSummaryTable onEdit={(id) => {
                                if (userRole !== "user") {
                                    setCurrId(id);
                                    setMode("edit");
                                    setOpen(true);
                                }
                            }} onView={(id) => {
                                setCurrId(id);
                                setMode("view");
                                setOpen(true);
                            }}/>
                        </Card>
                    </React.Fragment>
                )}
            </C800CallLogsContext.Consumer>
        </C800CallLogsProvider>
    );
};
